"use strict";

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.bind");

var _deprecate = require("@nerdwallet/deprecate");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _has = _interopRequireDefault(require("lodash/has"));

var _pull = _interopRequireDefault(require("lodash/pull"));

var _delay = _interopRequireDefault(require("lodash/delay"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/lib/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/lib/Popover"));

var _popoverModule = _interopRequireDefault(require("./popover.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {}; // Using a wrapper for the full width popover so we can control its positioning (Overlay does it otherwise)


var PopoverWrapper = function PopoverWrapper(props) {
  var popoverPadding = props.popoverPadding,
      popoverArrowOffsetLeft = props.popoverArrowOffsetLeft,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["popoverPadding", "popoverArrowOffsetLeft", "children"]);

  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({}, otherProps, {
    bsClass: _popoverModule["default"].popover,
    arrowOffsetLeft: popoverArrowOffsetLeft,
    style: {
      left: "".concat(popoverPadding, "px"),
      right: "".concat(popoverPadding, "px")
    }
  }), children);
};

PopoverWrapper.displayName = 'PopoverWrapper';
PopoverWrapper.propTypes = {
  popoverArrowOffsetLeft: _propTypes["default"].number,
  popoverPadding: _propTypes["default"].number,
  children: _propTypes["default"].node
};
PopoverWrapper.defaultProps = {
  popoverPadding: 18,
  popoverArrowOffsetLeft: 0,
  children: null
};

var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleHoverContentMouseOver", function () {
      _this.hide = noop; // prevent hiding popover when user is hovering over content

      _this.BSOverlayTrigger.show();
    });

    _defineProperty(_assertThisInitialized(_this), "handleHoverContentMouseOut", function () {
      _this.hide = _this.BSOverlayTrigger.hide.bind(_this.BSOverlayTrigger);
      (0, _delay["default"])(function () {
        _this.hide();
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnterOverlay", function (node) {
      var onShow = _this.props.onShow;

      _this.setState({
        isPopoverOpen: true
      });

      onShow(node); // node element, not event object
    });

    _defineProperty(_assertThisInitialized(_this), "handleExitOverlay", function (node) {
      var onHide = _this.props.onHide;

      _this.setState({
        isPopoverOpen: false
      });

      onHide(node); // node element, not event object
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTouchEnd", function (triggers) {
      var isPopoverOpen = _this.state.isPopoverOpen;

      if (!triggers.includes('click')) {
        if (isPopoverOpen) {
          _this.BSOverlayTrigger.hide();
        } else {
          _this.BSOverlayTrigger.show();
        }
      }
    });

    _this.state = {
      isPopoverOpen: false
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "show",
    value: function show() {
      this.BSOverlayTrigger.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.BSOverlayTrigger.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          container = _this$props.container,
          fullWidthProps = _this$props.fullWidthProps,
          id = _this$props.id,
          onClick = _this$props.onClick,
          placement = _this$props.placement,
          popoverClassName = _this$props.popoverClassName,
          popoverContent = _this$props.popoverContent,
          rootClose = _this$props.rootClose,
          shouldDelay = _this$props.shouldDelay,
          type = _this$props.type;
      var triggers = typeof type === 'string' ? [type] : _toConsumableArray(type);
      (0, _pull["default"])(triggers, 'manual', 'hoverContent'); // TODO: What does `manual` do???
      // Extended "hoverContent" behavior:
      // Allow the popover content to be hoverable,
      // by adding a timeout to the mouseout,
      // and adding a mouseover/out to the content.

      var isHoverContentTrigger = (0, _includes["default"])(type, 'hoverContent');
      var onMouseOut = isHoverContentTrigger ? this.handleHoverContentMouseOut : null;
      var onMouseOver = isHoverContentTrigger ? this.handleHoverContentMouseOver : null;

      if (isHoverContentTrigger && !(0, _has["default"])(triggers, 'hover')) {
        triggers.push('hover');
      }

      var popoverProps = {
        id: id,
        // `role` should be paired with `aria-describedby`
        role: 'tooltip',
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        bsClass: _popoverModule["default"].popover,
        className: (0, _classnames["default"])(popoverClassName, {
          'full-width': fullWidthProps
        })
      };
      var overlay = fullWidthProps ? /*#__PURE__*/_react["default"].createElement(PopoverWrapper, _extends({}, popoverProps, fullWidthProps), popoverContent) : /*#__PURE__*/_react["default"].createElement(_Popover["default"], popoverProps, popoverContent);
      return /*#__PURE__*/_react["default"].createElement(_OverlayTrigger["default"], {
        ref: function ref(BootStrapOverlayTrigger) {
          _this2.BSOverlayTrigger = BootStrapOverlayTrigger;
        },
        container: container,
        containerPadding: 10,
        delay: shouldDelay ? 1500 : null,
        onClick: onClick,
        overlay: overlay,
        placement: placement,
        rootClose: rootClose,
        trigger: triggers,
        onEnter: this.handleEnterOverlay,
        onExit: this.handleExitOverlay
      }, /*#__PURE__*/_react["default"].createElement("span", {
        // `aria-describedby` should be paired with `role=tooltip`
        "aria-describedby": id,
        className: (0, _classnames["default"])([className, _popoverModule["default"]['popover-overlay-trigger']]) // `onTouchEnd` for touch device accessibility
        ,
        onTouchEnd: this.handleOnTouchEnd.bind(this, triggers)
      }, children));
    }
  }]);

  return Popover;
}(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Popover.displayName = 'Popover'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Popover.propTypes = {
  /**
   * Recommended; otherwise the tooltip may not be usable
   */
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,

  /**
   * An DOM element to which to append the overlay
   */
  container: _propTypes["default"].node,

  /**
   * If `fullWidthProps` is truthy, then overlay will be full width
   */
  fullWidthProps: _propTypes["default"].shape({
    popoverPadding: _propTypes["default"].number,
    popoverArrowOffsetLeft: _propTypes["default"].number
  }),

  /**
   * An HTML id attribute. Highly recommended to define for accessibility.
   */
  id: _propTypes["default"].string,

  /**
   * Callback when the overlay is clicked on
   */
  onClick: _propTypes["default"].func,

  /**
   * Callback when the popover is shown.
   */
  onHide: _propTypes["default"].func,

  /**
   * Callback when the popover is shown
   */
  onShow: _propTypes["default"].func,

  /**
   * Direction the popover is positioned towards.
   */
  placement: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
  popoverClassName: _propTypes["default"].string,
  popoverContent: _propTypes["default"].node,

  /**
   * Whether clicking on the `root` closes the overlay
   */
  rootClose: _propTypes["default"].bool,

  /* Whether the overlay is shown after a certain delay
   * Generally used to give users more time to hover over the AdvertiserDisclosure.
   */
  shouldDelay: _propTypes["default"].bool,

  /**
   * How the overlay should be triggered
   */
  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['manual', 'click', 'hover', 'focus', 'hoverContent']), _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['click', 'hover', 'focus', 'hoverContent']))])
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Popover.defaultProps = {
  children: null,
  className: '',
  container: null,
  fullWidthProps: null,
  id: '',
  onClick: function onClick() {},
  onHide: function onHide() {},
  onShow: function onShow() {},
  placement: 'bottom',
  popoverClassName: '',
  popoverContent: null,
  rootClose: false,
  shouldDelay: false,
  type: ['hoverContent', 'click']
};

var _default = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  (0, _deprecate.useDeprecatedComponentWarning)({
    component: 'Popover',
    version: '3.3.17',
    migration: 'Use <Tooltip /> from `@nerdwallet/react-tooltip` instead.'
  });
  return /*#__PURE__*/_react["default"].createElement(Popover, _extends({}, props, {
    ref: ref
  }));
});

exports["default"] = _default;